/**
 * Shared accessibility utilities — focus trap, escape handlers, roving tabindex
 */
(function () {
  'use strict';

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  window.OrichA11y = {
    getFocusable(container) {
      return Array.from(container.querySelectorAll(FOCUSABLE)).filter(
        (el) => !el.closest('[hidden],[aria-hidden="true"]') && el.offsetParent !== null
      );
    },

    trapFocus(container, event) {
      if (event.key !== 'Tab') return;
      const focusable = this.getFocusable(container);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    closeOnEscape(closeFn) {
      return (event) => {
        if (event.key === 'Escape') closeFn();
      };
    },
  };
})();
